/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types, no-unused-vars, no-shadow */
import React from 'react';
import _ from 'underscore';
import { Radio } from './radio';
import {
  IRadioGroupItem, IRadioGroupItemValue, IRadioGroupState, IRadioGroupGetItemId, IRadioGroupGetItemValue,
  IRadioGroupRenderItem,
} from './types';

export interface IRadioGroupProps<T extends IRadioGroupItemValue = IRadioGroupItem> {
  checked?: T | null;
  className?: string;
  disabled?: boolean;
  getItemId?: IRadioGroupGetItemId<T>;
  getItemValue?: IRadioGroupGetItemValue<T> | null;
  items: T[];
  name?: string;
  onChange: (item: T) => void;
  renderItem?: IRadioGroupRenderItem<T>;
}

export class RadioGroup<T extends IRadioGroupItemValue = IRadioGroupItem> extends React.PureComponent<IRadioGroupProps<T>, IRadioGroupState> {
  static defaultProps = {
    checked: null as IRadioGroupItem | null,
    disabled: false,
    getItemId: (item: IRadioGroupItem, index: number) => String(index),
    getItemValue: null as IRadioGroupGetItemValue<IRadioGroupItem> | null,
    name: null as string | null,
    renderItem: (): React.ReactNode => null,
  };

  static getDerivedStateFromProps<T extends IRadioGroupItemValue>(nextProps: IRadioGroupProps<T>, prevState: IRadioGroupState): IRadioGroupState {
    return {
      name: nextProps.name || prevState.name || _.uniqueId('radio-group-'),
    };
  }

  constructor(props: IRadioGroupProps<T>) {
    super(props);
    this.state = {};
  }

  render() {
    const getItemValue = this.props.getItemValue || this.props.getItemId;

    return (
      <>
        {this.props.items.map((item, index) => {
          const id = this.props.getItemId!(item, index);
          const itemDisabled = (item as IRadioGroupItem).disabled;
          const onChange = () => {
            this.props.onChange(item);
          };

          return (
            <Radio
              key={id}
              id={`${this.state.name}-${id}`}
              checked={this.props.checked === item}
              disabled={itemDisabled || this.props.disabled}
              name={this.state.name}
              onChange={onChange}
              value={getItemValue!(item, index) as any}
            >
              {this.props.renderItem(item, index) as any}
            </Radio>
          );
        })}
      </>
    );
  }
}
